export default __webpack_public_path__ + "static/media/SeminarioIes2026_JaredSmith.d2318f28.jpg";